import { Button, Stack, useMediaQuery, useTheme } from "@mui/material";
import { DialogWindow } from "UI/DialogWindow";

const Prop = ({ children }) => (
  <div className="flex flex-row gap-1 justify-between items-start text-sm">
    {children}
  </div>
);

const Label = ({ children }) => <div className="flex-shrink-0">{children}</div>;

const Value = ({ children }) => (
  <div className="text-black text-left">{children ? children : "-"}</div>
);

export const AccessDetailsDialog = ({ selectedRow, handleClose }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const mobileButtonSx = { padding: "10px 10px" };
  const sx = isMobile ? mobileButtonSx : {};

  const {
    id,
    createdAt,
    description,
    sourceIp,
    method,
    url,
    token,
    userAgent,
    userId,
    userName,
    userEmail,
    userPhone,
    buttonId,
  } = selectedRow;

  return (
    <DialogWindow
      open={!!selectedRow?.id}
      withCloseButton
      handleClose={handleClose}
      title={"View Access Details"}
      content={
        <div className="flex flex-row mt-3 gap-3 flex-wrap max-w-96">
          <Prop>
            <Label>Id:</Label>
            <Value>{id}</Value>
          </Prop>
          <Prop>
            <Label>Created At:</Label>
            <Value>
              {createdAt
                ? new Intl.DateTimeFormat("en-US", {
                    dateStyle: "short",
                    timeStyle: "medium",
                  }).format(new Date(createdAt))
                : "-"}
            </Value>
          </Prop>
          <Prop>
            <Label>Description:</Label>
            <Value>{description}</Value>
          </Prop>
          <Prop>
            <Label>Source IP:</Label>
            <Value>{sourceIp}</Value>
          </Prop>
          <Prop>
            <Label>Method:</Label>
            <Value>{method}</Value>
          </Prop>
          <Prop>
            <Label>URL:</Label>
            <Value>{url}</Value>
          </Prop>
          <Prop>
            <Label>Token:</Label>
            <Value>{token}</Value>
          </Prop>
          <Prop>
            <Label>User Agent:</Label>
            <Value>{userAgent}</Value>
          </Prop>
          <Prop>
            <Label>User Id:</Label>
            <Value>{userId}</Value>
          </Prop>
          <Prop>
            <Label>User Name:</Label>
            <Value>{userName}</Value>
          </Prop>
          <Prop>
            <Label>User Email:</Label>
            <Value>{userEmail}</Value>
          </Prop>
          <Prop>
            <Label>User Phone:</Label>
            <Value>{userPhone}</Value>
          </Prop>
          <Prop>
            <Label>Button Id:</Label>
            <Value>{buttonId}</Value>
          </Prop>
        </div>
      }
      actions={
        <Stack
          mt={2}
          mb={2}
          width={"100%"}
          direction={"row"}
          justifyContent={"center"}
          alignItems={"center"}
          gap={1}
        >
          <Button variant="contained" onClick={handleClose} sx={sx}>
            Close
          </Button>
        </Stack>
      }
    />
  );
};
